import { Expression } from 'mapbox-gl';

// cspell: disable
const OPACITY = 0.45;
const POOR_COLOR = '#808080'; // very-light-grey]
const COLOR_RANKING = [
  { text: 'Great', color: 'rgb(253,107,107)' },
  { text: 'Very Good', color: 'rgb(250,160,160)' },
  { text: 'Good', color: 'rgb(255,192,0)' },
  { text: 'Fair', color: 'rgb(253,210,103)' },
  { text: 'Poor', color: 'rgb(255,255,0)' },
  { text: 'No Fit', color: POOR_COLOR },
];
// cspell: enable

const colorExpression = (): Expression => {
  const caseStatement: Expression = ['case'];
  COLOR_RANKING.forEach((ranking, index) => {
    caseStatement.push(['==', ['to-number', ['get', 'overall_rank']], index + 1], ranking.color);
  });
  caseStatement.push(POOR_COLOR);
  return caseStatement;
};

export { COLOR_RANKING, OPACITY, colorExpression };
